import axios from '@/libs/axios';

class GamificationClient {
  constructor() {
    this.api = axios;
  }

  async getEventTypes() {
    const { data } = await this.api.get('/gamification/event-types');
    return data;
  }

  async listCampaigns(params) {
    const { data } = await this.api.get('/gamification/campaigns', { params });
    return data;
  }

  async getCampaign(id) {
    const { data } = await this.api.get(`/gamification/campaigns/${id}`);
    return data;
  }

  async getCampaignOverview(id) {
    const { data } = await this.api.get(`/gamification/campaigns/${id}/overview`);
    return data;
  }

  async createCampaign(payload) {
    const { data } = await this.api.post('/gamification/campaigns', payload);
    return data;
  }

  async updateCampaign(id, payload) {
    const { data } = await this.api.put(`/gamification/campaigns/${id}`, payload);
    return data;
  }

  async deleteCampaign(id) {
    const { data } = await this.api.delete(`/gamification/campaigns/${id}`);
    return data;
  }

  async duplicateCampaign(id) {
    const { data } = await this.api.post(`/gamification/campaigns/${id}/duplicate`);
    return data;
  }

  async seedDefaultRules(id) {
    const { data } = await this.api.post(`/gamification/campaigns/${id}/seed-rules`);
    return data;
  }

  async listRules(campaignId) {
    const { data } = await this.api.get(`/gamification/campaigns/${campaignId}/rules`);
    return data;
  }

  async createRule(campaignId, payload) {
    const { data } = await this.api.post(`/gamification/campaigns/${campaignId}/rules`, payload);
    return data;
  }

  async updateRule(id, payload) {
    const { data } = await this.api.put(`/gamification/rules/${id}`, payload);
    return data;
  }

  async deleteRule(id, campaignId) {
    const { data } = await this.api.delete(`/gamification/rules/${id}`, { params: { campaign_id: campaignId } });
    return data;
  }

  async listMissions(campaignId) {
    const { data } = await this.api.get(`/gamification/campaigns/${campaignId}/missions`);
    return data;
  }

  async createMission(campaignId, payload) {
    const { data } = await this.api.post(`/gamification/campaigns/${campaignId}/missions`, payload);
    return data;
  }

  async updateMission(id, payload) {
    const { data } = await this.api.put(`/gamification/missions/${id}`, payload);
    return data;
  }

  async deleteMission(id, campaignId) {
    const { data } = await this.api.delete(`/gamification/missions/${id}`, { params: { campaign_id: campaignId } });
    return data;
  }

  async listBadges(campaignId) {
    const { data } = await this.api.get(`/gamification/campaigns/${campaignId}/badges`);
    return data;
  }

  async createBadge(campaignId, payload) {
    const { data } = await this.api.post(`/gamification/campaigns/${campaignId}/badges`, payload);
    return data;
  }

  async updateBadge(id, payload) {
    const { data } = await this.api.put(`/gamification/badges/${id}`, payload);
    return data;
  }

  async deleteBadge(id, campaignId) {
    const { data } = await this.api.delete(`/gamification/badges/${id}`, { params: { campaign_id: campaignId } });
    return data;
  }

  async getLeaderboard(campaignId, params) {
    const { data } = await this.api.get(`/gamification/campaigns/${campaignId}/leaderboard`, { params });
    return data;
  }

  async getTransactions(campaignId, params) {
    const { data } = await this.api.get(`/gamification/campaigns/${campaignId}/transactions`, { params });
    return data;
  }

  async addManualPoints(campaignId, payload) {
    const { data } = await this.api.post(`/gamification/campaigns/${campaignId}/manual-points`, payload);
    return data;
  }

  async getAuditLog(campaignId, params) {
    const { data } = await this.api.get(`/gamification/campaigns/${campaignId}/audit`, { params });
    return data;
  }

  async getRepresentanteStats(campaignId, repId) {
    const { data } = await this.api.get(`/gamification/campaigns/${campaignId}/representante/${repId}`);
    return data;
  }

  async getWidgetData(representanteId) {
    const { data } = await this.api.get('/gamification/widget', { params: { representante_id: representanteId } });
    return data;
  }

  async getDashboardData(representanteId) {
    const { data } = await this.api.get('/gamification/dashboard', { params: { representante_id: representanteId } });
    return data;
  }
}

export default new GamificationClient();
